import ProductsDataTable from "./components/DataTable";

export default function Products(): React.ReactElement {
  return <ProductsDataTable />;
}
